import {Question} from '@agenium-ai/agenium-client-sdk/dist/models';

const patchQuestions = [
    {
        //Testing Purposes question
        referenceId: '5f727d5f-7202-478e-9eb6-bfa6104cfc66',
        validationExpressions: [],
    },
    {
        referenceId: 'da6c43e7-f337-42d2-8d72-bd6a1683a304',
        validationRegex: '^(100|[1-9][0-9]|[1-9])$',
    },
    {
        referenceId: 'e07c4ff5-18d6-41c9-899a-98e4a6404dfc',
        validationRegex: '^(100|[1-9][0-9]|[1-9])$',
    },
    {
        referenceId: '649bbd77-be0d-493b-a4b8-a2d193476316',
        allowedValues: [
            {
                id: 'Respiratory',
                displayName: 'Disorder(s) or disease(s) of the Respiratory System?',
                helpText: 'Asthma, COPD, Sleep Apnea',
                helpTextExpanded:
                    'Asthma, Chronic Obstructive Pulmonary Disease (COPD), Allergies, Bronchitis, Pneumonia, Sleep Apnea (Obstructive Sleep Apnea, Central Sleep Apnea, Mixed Sleep Apnea), Pulmonary Fibrosis or Interstitial Lung Disease, Pulmonary Nodule, Cystic Fibrosis, Pulmonary Embolism (PE), Cancer, tumor, or malignancy of the Respiratory System, Any other disorder or disease of the Respiratory System',
                sortOrder: 0,
            },
            {
                id: 'Cancer',
                displayName: 'Cancer(s), tumor(s), cyst(s) or nodule(s)?',
                helpText: 'Benign tumor or cyst or nodule, Cancer, Melanoma, Skin Cancer',
                helpTextExpanded:
                    'Benign (Non-Malignant) Tumor, Cyst or Nodule, Breast Cancer, Ovarian Cancer, Lung Cancer, Colorectal Cancer, Prostate Cancer, Lymphoma, Melanoma, Basal Cell Carcinoma, Squamous Cell Carcinoma, or Other Non-Melanoma Skin Cancer, Leukemia, Pancreatic Cancer, Kidney Cancer, Bladder Cancer, Thyroid Cancer, Brain Cancer or Meningioma, Any other cancer, tumor, cyst, or nodule',
                sortOrder: 1,
            },
            {
                id: 'Mental',
                displayName: 'Psychiatric or mental health disorder(s) or disease(s)?',
                helpText: 'Anxiety, PTSD, ADD or ADHD, Depression, Bipolar, Schizophrenia',
                helpTextExpanded:
                    'Anxiety, Obsessive-Compulsive Disorder (OCD), Stress Disorders, Post-Traumatic Stress Disorder (PTSD), Panic Disorder, Attention Deficit Disorder (ADD), Attention Deficit Hyperactivity Disorder (ADHD), Mood Disorders: Depression, Dysthymia, Bipolar Disorder, Schizophrenia, or Psychosis, Eating Disorders: Anorexia Nervosa, Bulimia Nervosa, Binge Eating Disorder, Personality Disorders, Autism Spectrum Disorder (ASD), Sleep Disorders: Insomnia, Narcolepsy, Any other psychiatric or mental health disorder or disease',
                sortOrder: 2,
            },
            {
                id: 'Cardio',
                displayName: 'Disorder(s) or disease(s) of the Heart, Blood Vessels, or Circulatory System?',
                helpText: 'High Blood Pressure, High Cholesterol, a Heart Murmur, Coronary Artery Disease, Atrial Fib',
                helpTextExpanded:
                    'Hypertension or High Blood Pressure, High Cholesterol or Elevated Lipids, Heart Attack or Myocardial Infarction, Heart Valve Disorder, Heart Murmur, Heart Failure, Congestive Heart Failure, or Cardiomyopathy, Coronary Artery Disease (CAD), Irregular Heartbeat, Arrhythmia, Atrial Fibrillation, Atrial Flutter, Heart Rhythm Disorders, Stroke, Transient Ischemic Attack (TIA), Peripheral Artery Disease (PAD), Peripheral Vascular Disease (PVD), Deep Vein Thrombosis (DVT), Pulmonary Embolism (PE), Aneurysm, Bleeding or Clotting Disorder, Chest Discomfort, Raynaud’s Syndrome, Cancer, tumor, or malignancy of the Heart, Blood Vessels, or Circulatory System, Any other disorder or disease of the Heart, Blood Vessels, or Circulatory System',
                sortOrder: 3,
            },
            {
                id: 'Digestive',
                displayName:
                    'Disorder(s) or disease(s) of the Stomach, Liver, Intestines, Rectum, or Pancreas, or Abdominal Organs?',
                helpText: "GERD, IBS, Crohn's Disease, Ulcerative Colitis, Gallstones",
                helpTextExpanded:
                    'Gastroesophageal Reflux Disease (GERD), Peptic Ulcer Disease (PUD), Inflammatory Bowel Disease (IBD): Crohn’s Disease, Ulcerative Colitis, Irritable Bowel Syndrome (IBS), Chronic Liver Disease, Cirrhosis, or Liver Failure, Hepatitis, Gallstones, Cholecystitis, Pancreatitis, Celiac Disease, Diverticulitis, Diverticulosis, Cancer, tumor, or malignancy of the Stomach, Liver, Intestines, Rectum, or Pancreas, Any other disorder or disease of the Stomach, Liver, Intestines, Rectum, or Pancreas, or Abdominal Organs',
                sortOrder: 4,
            },
            {
                id: 'Gynecological',
                displayName: 'Genitourinary and Gynecological disorder(s) or disease(s)?',
                helpText: 'BPH or Enlarged Prostate, Uterine Fibroids, Ovarian Cyst, STD',
                helpTextExpanded:
                    'Abnormal Pap Smear, Endometriosis, Benign Prostatic Hyperplasia (BPH), Enlarged Prostate, Polycystic Ovarian Syndrome (PCOS), Uterine Fibroids, Ovarian Cysts, Sexually Transmitted Disease (STDs), Sexually Transmitted Infections (STIs), Genitourinary or Gynecological cancer, tumor, or malignancy, Any other Genitourinary and Gynecological disorders or diseases',
                sortOrder: 5,
            },
            {
                id: 'Skeletal',
                displayName: 'Disorder(s) or disease(s) of the Skeletal System?',
                helpText: 'Arthritis, Joint Replacement, Disc disorder, Rheumatoid Arthritis',
                helpTextExpanded:
                    'Arthritis, Rheumatoid Arthritis, Fracture, Broken Bone, Chronic Pain, Pain, Fibromyalgia, Gout, Amputation, Joint Replacement, Spine, Disc Disorder, Osteoporosis, Osteopenia, Carpal Tunnel Syndrome, Cancer, tumor, or malignancy of the Skeletal System, Any other disorder or disease of the Skeletal System',
                sortOrder: 6,
            },
            {
                id: 'Lymphatic',
                displayName: 'Disorder(s) or disease(s) of the Blood, Skin, Thyroid, Lymph or other Glands?',
                helpText: 'Diabetes, Pre-Diabetes, Glucose Intolerance, Hypothyroidism',
                helpTextExpanded:
                    'Type I Diabetes, Type II Diabetes, Gestational Diabetes, pregnancy-related diabetes, Impaired Fasting Glucose, Glucose Intolerance, Hyperglycemia, Pre-Diabetes, Addison’s disease, Cushing’s disease, pituitary gland disorder, Grave’s disease, Hypothyroidism, Hyperthyroidism, Thyroiditis, Thyroid Nodule, Goiter, Anemia, Hemophilia, Sickle Cell Disease, Thrombocytopenia, Polycythemia Vera, Lymphedema, Lymphoma, Cancer, tumor, or malignancy of the Blood, Skin, Thyroid, or other Glands, Any other disorder or disease of the Blood, Skin, Thyroid, Lymph or other Glands',
                sortOrder: 7,
            },
            {
                id: 'Urinary',
                displayName: 'Disease(s) or disorder(s) of the Urinary System?',
                helpText: 'Kidney Stones, Prostatitis, UTI, Overactive Bladder',
                helpTextExpanded:
                    'Kidney Disease, Chronic Kidney Disease, Kidney Failure, Renal Failure, Kidney Stones, Bladder Stones, Prostatitis, Urinary Tract Infections (UTIs), Glomerulonephritis, Polycystic Kidney Disease, Urinary Incontinence, Bladder Infection, Cystitis, Overactive Bladder, Cancer, tumor, or malignancy of the Urinary System, Any other disease or disorders of the Urinary System',
                sortOrder: 8,
            },
            {
                id: 'Peripheral',
                displayName: 'Disorder(s) or disease(s) of the eyes, ears, nose or throat?',
                helpText: "Dizziness, Vertigo, Meniere's disease, Glaucoma",
                helpTextExpanded:
                    'Dizziness, Vertigo, Syncope, Meniere’s Disease, Glaucoma, Cancer, tumor, or malignancy of the Eyes, Ears, Nose, or Throat, Any other disorder or disease of the Eyes, Ears, Nose, or Throat',
                sortOrder: 9,
            },
            {
                id: 'Nervous',
                displayName: 'Disorder(s) or disease(s) of the Brain or Nervous System?',
                helpText: 'Epilepsy or Seizure, Multiple Sclerosis, Stroke, TIA, Migraine',
                helpTextExpanded:
                    'Autism Spectrum Disorder, Alzheimer’s Disease, Amyotrophic Lateral Sclerosis (ALS), Brain Injury, Epilepsy, Seizure Disorder, Multiple Sclerosis (MS), Stroke, Transient Ischemic Attack (TIA), Parkinson’s Disease, Headache, Migraine, Dementia, Memory Loss, Any Cognitive Disorder, Cancer, tumor, or malignancy of the Brain or Nervous System, Any other disorder or disease of the Brain or Nervous System',
                sortOrder: 10,
            },
            {
                id: 'None of the above',
                displayName: 'None of the above',
                sortOrder: 11,
            },
        ],
    },
    {
        key: 'Case_Applicant_OwnerPISame',
        showMessageOnValue: [
            {
                value: 'No',
                title: 'Prosper does not currently support the Owner being different than the insured.',
                message:
                    'If the client wishes to proceed with a different owner, this application cannot be completed. Please close this application and select another product for the client',
                nextDisabled: true,
            },
        ],
    },
    {
        key: 'Case_Applicant_PayorPISame',
        showMessageOnValue: [
            {
                value: 'No',
                title: 'Prosper does not currently support the Payor being different than the insured.',
                message:
                    'If the client wishes to proceed with a different payor, this application cannot be completed. Please close this application and select another product for the client',
                nextDisabled: true,
            },
        ],
    },
    {
        key: 'Case_OtherInsurance_Replacement',
        showMessageOnValue: [
            {
                value: 'Yes',
                title: 'Prosper does not currently support replacements. ',
                message:
                    'If the client wishes to replace an existing policy (excluding employer coverage), this application cannot be completed. Please close this application and select another product for the client.',
                nextDisabled: true,
            },
        ],
    },
];

const autoPatchQuestion = (question: Question | undefined) => {
    if (question) {
        const patch = patchQuestions.find((e) => e?.referenceId === question.referenceId || e?.key === question.key);
        if (patch) return {...question, ...patch};
    }
    return question;
};

export default autoPatchQuestion;
